import * as Sentry from '@sentry/react';
import React, { Fragment } from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import { EventYearFilterProvider } from 'components/Events';
import { TransactionDateFilterProvider } from 'components/Transactions/TransactionDateFilter';
import { CartProvider } from 'shared/CartContext';
import { FilterProvider } from 'shared/filterContext';
import { MembershipProvider } from 'shared/membershipContext';
import { TransactionFilterProvider } from 'shared/transactionFilterContext';
import App from './routes';
import * as serviceWorker from './serviceWorker';
import AppProvider from './shared/AppContext';
import UpdateAlert from './updateAlert';

const environment = process.env.REACT_APP_SENTRY_ENVIRONMENT || 'development';

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,
  environment,
  release: process.env.REACT_APP_COMMIT_REF || undefined,
  tracesSampleRate: environment === 'production' ? 0.2 : 1.0,
  initialScope: {
    tags: { platform: process.env.REACT_APP_PLATFORM || 'unknown' },
  },
});

// Prevent scroll wheel from changing values on all number inputs globally
document.addEventListener(
  'wheel',
  function () {
    if (document.activeElement && document.activeElement.type === 'number') {
      document.activeElement.blur();
    }
  },
  { passive: true }
);

ReactDOM.render(
  <Fragment>
    <UpdateAlert />
    <AppProvider>
      <CartProvider>
        <FilterProvider>
          <TransactionFilterProvider>
            <EventYearFilterProvider>
              <MembershipProvider>
                <TransactionDateFilterProvider>
                  <App />
                </TransactionDateFilterProvider>
              </MembershipProvider>
            </EventYearFilterProvider>
          </TransactionFilterProvider>
        </FilterProvider>
      </CartProvider>
    </AppProvider>
  </Fragment>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.register({
//   onSuccess: () => console.log('success'),
//   onUpdate: reg => {
//     console.log('reg', reg);
//   }
// });
serviceWorker.register();
